import React from 'react';
import { useSelector } from 'react-redux';
import { Table, Checkbox, BodyText } from '@gaiads/telia-react-component-library';

import SalesChannelInfo from '../../../shared/ListUtil/SalesChannelInfo';
import { RootState } from '../../../store';
import { selectAllSalesChannels } from '../../../store/salesChannels';
import { ProductsListItem } from './ProductsList';
import PropertiesText from './PropertiesText';

interface ProductListVariantItemProps {
  variant: ProductsListItem;
  onProductChecked: (product: ProductsListItem) => void;
  onClickProductRow: (product: ProductsListItem) => void;
  selected: boolean;
  open: boolean;
}

export default function ProductListVariantItem({ variant, open, onProductChecked, onClickProductRow, selected }: ProductListVariantItemProps) {
  const allSalesChannels = useSelector((state: RootState) => selectAllSalesChannels(state));
  const { brand, name, sku, sales_channel_uuids, properties } = variant;

  return (
    <Table.Row className="telia-react-table_row__child" hidden={!open}>
      <Table.Cell type="checkbox"></Table.Cell>
      <Table.Cell type="checkbox">
        <Checkbox checked={selected} onChange={() => onProductChecked(variant)} onClick={event => event.stopPropagation()} />
      </Table.Cell>
      <Table.Cell className="daas-product-table__brand" onClick={() => onClickProductRow(variant)}>
        <BodyText>{brand}</BodyText>
      </Table.Cell>
      <Table.Cell className="daas-product-table__name" onClick={() => onClickProductRow(variant)}>
        <BodyText>
          {name}
          <PropertiesText properties={properties} />
        </BodyText>
      </Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell>
        <BodyText>{sku}</BodyText>
      </Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell>{/*<AvailabilityIndicator/>*/}</Table.Cell>
      <Table.Cell>
        <SalesChannelInfo allSalesChannels={allSalesChannels} variantSalesChannelUuids={sales_channel_uuids} />
      </Table.Cell>
    </Table.Row>
  );
}
